import { observer } from "mobx-react";
import { Button } from "primereact/button";
import React, { useContext } from "react";
import styled from "styled-components";
import { useLocStore } from "../../../../wsLocalization";
import { LocContext } from "../../../../wsLocalization/LocContext";
import { concatClassnames } from "../../../../WSUtils/util";
import { WSFormGrid } from "../../../../WSUtils/WSFormGrid";
import { CVEditContext } from "../../CVEditContext";
import { CVEditDocument } from "../Components/CVEditDocument";
import { CVEditDocumentBaseList } from "../Components/CVEditDocumentsBaseList";
import { CVEditAttachmentsSegmentStore } from "./CVEditAttachmentsSegmentStore";

export interface CVEditAttachmentPickerProps {
  attachmentsSegmentStore: CVEditAttachmentsSegmentStore;
}

export const CVEditAttachmentPicker = observer(
  ({ attachmentsSegmentStore }: CVEditAttachmentPickerProps) => {
    const L = useLocStore(LocContext.CV);
    const cvEditContext = useContext(CVEditContext);

    const items = attachmentsSegmentStore.unattachedDocuments;

    return (
      <CVEditAttachmentPickerStyles
        className={concatClassnames([
          "cve-list cve-attachment-picker cve-x-editor",
          cvEditContext.layoutClassName,
        ])}
      >
        <div className="cvp-h3 cve-smaller-header">
          {L.id("650956f4a424").loc("Legg ved dokumenter")}

          <Button
            icon="pi pi-times"
            className={concatClassnames([
              "p-button-text p-button-icon-only p-button-rounded",
              "cve-editor-cancel",
            ])}
            onClick={(evt) => {
              evt.preventDefault();

              attachmentsSegmentStore.showAttachmentPickerHint = false;

              return false;
            }}
          />
        </div>
        {items.length > 0 && (
          <>
            <div className="cve-attachment-picker-emphasis">
              {L.id("fba928b90e02").loc("Fra dokumentlisten din")}:
            </div>
            <StyledCVEditDocumentBaseList
              className={concatClassnames([
                cvEditContext.layoutClassName,
                "cve-attachment-picker-list",
              ])}
              items={items}
              OnRenderButtons={(props) => (
                <OnRenderButtons
                  cveDocument={props.cveDocument}
                  attachmentsSegmentStore={attachmentsSegmentStore}
                />
              )}
            />
          </>
        )}
      </CVEditAttachmentPickerStyles>
    );
  }
);

interface OnRenderButtonsProps {
  cveDocument: CVEditDocument;
  attachmentsSegmentStore: CVEditAttachmentsSegmentStore;
}

const OnRenderButtons = observer(
  ({ cveDocument, attachmentsSegmentStore }: OnRenderButtonsProps) => {
    const L = useLocStore(LocContext.CV);
    const cvEditContext = useContext(CVEditContext);

    return (
      <Button
        className="p-button-outlined cve-attach-already-uploaded-document-button"
        label={L.id("93a2652fbb84").loc("Legg ved")}
        onClick={(evt) => {
          evt.persist();

          attachmentsSegmentStore.addPersistedAttachment(cveDocument.id);

          return false;
        }}
      />
    );
  }
);

const StyledCVEditDocumentBaseList = styled(CVEditDocumentBaseList)`
  max-height: 300px;
  overflow: auto;
  margin-left: -1rem;
  padding-left: 1rem;

  .cve-listing-buttons {
    margin-right: 0.5rem;
  }
`;

export const CVEditAttachmentPickerStyles = styled(WSFormGrid)`
  .cve-attach-already-uploaded-document-button {
    padding: 0.15rem 0.35rem;
    font-size: 0.75em;
    font-weight: bold;
  }

  .cve-attachment-picker-emphasis {
    color: var(--text-color-secondary);
    font-style: italic;
  }
`;
